/**
 * @ngdoc service
 * @name fileUtils
 * @description
 * The idea of this is to handle local files.
 *
 * @memberof common
 */
class FileUtils {
  /**
   * Class constructor.
   * @param {Service} $q             Most of the file methods make use of a callback,
   *                                 so we use `$q` to wrap all the async functionalities.
   * @param {Object}  $window        To get access to the `FileReader` API.
   * @param {Object}  appConstant    To get the allowed max file size.
   * @param {Service} fileTypes      To be able check the files type.
   * @ignore
   */
  constructor(
    $q,
    $window,
    appConstant,
    fileTypes,
  ) {
    'ngInject';

    /**
     * The local reference to the `$q` service.
     * @type {Object}
     */
    this.$q = $q;
    /**
     * The local reference to the `$window` service.
     * @type {Object}
     */
    this.$window = $window;
    /**
     * The local reference to the `fileTypes` service.
     * @type {Service}
     */
    this.fileTypes = fileTypes;
    /**
     * The limit of the filesize per upload.
     * @type {Number}
     */
    this.maxFileSize = appConstant.imagePreviewerJS.maxFileSize;
    /**
     * The defaultSize to return in formatBytes.
     * @type {String}
     */
    this.defaultSize = '0 Bytes';
    /**
     * The posible size types array.
     * @type {Array}
     */
    this.sizeTypes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    /**
     * The human readable limit of the filesize per upload.
     * @type {Number}
     */
    this.displayMaxFileSize = this._formatBytes(this.maxFileSize);
  }
  _formatBytes(bytes) {
    if (bytes === 0) {
      return this.defaultSize;
    }
    const k = 1024;
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    const val = parseFloat((bytes / (k ** i)).toFixed(0));

    return `${val}${this.sizeTypes[i]}`;
  }
  /**
   * Use the `FileReader` to get a file contents as a data URL.
   * @param {FileSystemEntry} file The file to read.
   * @return {Promise} Once the promise gets resolved,
   *                   the data URL will be saved on the object
   *                   `base64` property.
   */
  readFile(file) {
    return this.$q((resolve, reject) => {
      const reader = new this.$window.FileReader();
      reader.onload = ({ target: { result } }) => {
        file.base64 = result;
        resolve(file);
      };

      reader.onerror = (event) => reject(event);
      reader.readAsDataURL(file, 'utf-8');
    });
  }
  /**
   * Evaluate if a File Object is an valid Image.
   * @param  {Object} file file object.
   * @return {Boolean}
   */
  isValidImage(file) {
    return (file.type && this.fileTypes.isAnImageType(file.type));
  }
  /**
   * Evaluate if a File Object has a valid size.
   * @param  {Object} file file object.
   * @return {Boolean}
   */
  hasRightSize(file) {
    return (file.size < this.maxFileSize);
  }
}

export default FileUtils;



// WEBPACK FOOTER //
// ./src/frontend/modules/common/services/fileUtils.js